
<template>
  <gj-select
    ref="virtualSelect"
    v-bind="$attrs"
    v-on="$listeners"
    type="custom"
    popper-class="gj-custom-select--popper"
    class="gj-virtual-select-more"
    :loading="loading"
    v-model="active"
    multiple
    collapse-tags
    @focus="handleFocus">
      <div @click.stop class="virtual-box-more">
        <el-input
          ref="searchInput"
          v-model="searchText"
          placeholder="搜索..."
          size="small"
        ></el-input>
        <el-option value="-1">
          <div class="select-all" @click.stop>
            <el-checkbox
              v-model="checked"
              @change="selectAll">
              全选
            </el-checkbox>
          </div>
        </el-option>
        <vxe-list :data="checkOptions" :scroll-y="{enabled: isVirtual}" :height="240" ref="vxeListRef">
          <template #default="{ items }">
            <el-option
              v-for="item in items"
              :key="item[valueKey]"
              :label="item[labelKey]"
              :value="item[valueKey]">
              <span class="checkbox" />
              <!-- <gj-tooltip :text-line="1" :content="item[labelKey]">{{item[labelKey]}}</gj-tooltip> -->
              <gj-text :width="'160px'" class="label-name-box">{{item[labelKey]}}</gj-text>
              <!-- <span class="label-name-box">{{ item[labelKey] }}</span> -->
            </el-option>
          </template>
        </vxe-list>
      </div>
  </gj-select>
</template>

<script>
import {isMeaningful, isMeaningless} from "@/utils/common";
export default {
  name:'gj-virtual-select',
  model:{
    prop:'value',
    event:'change'
  },
  props:{
    value:Array,
    list:{
      type:Array,
      required:true,
      default:function(){
        return []
      }
    },
    loading:{
      type:Boolean,
      default:false,
      checked:false
    },
    labelKey:{
      type:String,
      default:'text'
    },
    valueKey:{
      type:String,
      default:'id'
    },
    isVirtual: { // 虚拟滚动，默认开启。在下拉选项过多时虚拟滚动的数据无法正确回显，增加该配置用于解决虚拟滚动带来的BUG
      type:Boolean,
      default: true,
    }
  },
  data(){
    return{
      active:[],
      searchText:'',
      checkOptions:[],
      checked:false
    }
  },
  watch:{
    value:{
      handler(newVal,oldVal){
        this.active = newVal;
        if (isMeaningless(this.active) || (isMeaningful(this.active) && this.active.length === 0)) {
          //清空数据，清除搜索记录
          this.searchText = '';
        }
      },
      immediate:true
    },
    list:{
      handler(newval,oldVal){
        if(newval) this.checkOptions = newval
      },
      immediate:true
    },
    searchText:function(val){
      if(this.list.length>0){
        this.checkOptions = val === ''? this.list: this.list.filter(v=> v[this.labelKey].includes(val))
        this.setCheckValue()
      }
    },
    active:function(val){
      this.$emit('change', val);
      this.setCheckValue()
    }
  },
  methods:{
    // 全选多选处理
    selectAll(){
      if(this.checked){
        if(isMeaningless(this.active) || (isMeaningful(this.active) && this.active.length === 0)){
          this.active = this.checkOptions.map(v => v[this.valueKey]);
        }else {
          this.checkOptions.forEach(v=>{
            if (!this.active.includes(v[this.valueKey] )) {
              this.active.push(v[this.valueKey])
            }
          })
        }
      }else{
        this.checkOptions.forEach(v=>{
          const index =this.active.findIndex(item => item === v[this.valueKey])
          if (index >= 0) {
            this.active.splice(index, 1)
          }
        })
      }
    },
    // 设置全部勾选按钮
    setCheckValue (){
      this.checked = this.checkOptions.length>0 && this.checkOptions.every(v =>this.active.includes(v[this.valueKey]))
    },
    // 方案2 移到上次滚动位置
    handleFocus(){
      this.$refs.vxeListRef.refreshScroll()
      // 滚动1px解决虚拟滚动白屏问题
      setTimeout(() => {
        this.$refs.vxeListRef.scrollTo(0, 1);
      }, 100);
    }
  }
}
</script>

<style lang="scss" >
.gj-virtual-select-more{
  .el-select__tags{
    .el-tag{
      max-width: 72px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.virtual-box-more{
  padding: 6px 0px;
  max-width: 206px;
  >.el-input{
    margin: 0 8px;
    width: 190px;
  }
  .select-all {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    height: 32px;
    line-height: 32px;
    width: 100%;
    padding: 0 12px;

   .el-checkbox {
      width: 100%;
    }
  }
}
.gj-custom-select--popper .vxe-list .el-select-dropdown__item{
  padding: 0 12px !important;
  overflow: unset;
  text-emphasis: none;
}
.gj-custom-select--popper .vxe-list .el-select-dropdown__item:hover{
  background-color: #EDF7FF !important;
}
/* 清空原来的多选框样式 */
.el-select-dropdown.is-multiple .el-select-dropdown__item::after {
  content: '';
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  content: '';
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  background-color: #FFFFFF;
  color: #333333;
  font-weight: 500;
}

/* 参考el-checkbox实现checkbox样式 */
.el-select-dropdown.is-multiple .el-select-dropdown__item .checkbox {
  background-color: #FFFFFF;
  border: 1px solid #D8DADD;
  border-radius: 2px;
  box-sizing: border-box;
  display: inline-block;
  height: 14px;
  margin-right: 12px;
  position: relative;
  transition:
  border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
  background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
  vertical-align: middle;
  width: 14px;
  z-index: 1;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected .checkbox {
  background-color: #1F6EEF;
  border-color: #1F6EEF;
}

/* 参考el-select多选对号样式实现checkbox中对号的样式 */
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected .checkbox::after {
  color: #FFFFFF;
  content: '\e6da';
  font-family: element-icons;
  font-size: 12px;
  -webkit-font-smoothing: antialiased;
  font-weight: 700;
  position: absolute;
  top: -10px;
}

/* 设置置灰内容样式 */
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected.is-disabled .checkbox {
  background-color: #E4E5E6;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected.is-disabled .checkbox::after {
  color: #666666;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected.is-disabled .label-name-box {
  color: #666666;
  font-weight: 400;
}

</style>
